import React, { useEffect, useState } from 'react';
import { Select as AntdSelect } from 'antd';
import { useClient } from 'src/contexts/Client/Client';
import { filterApiResponse } from 'src/features/Groups/Details/Members/utils';
import { MemberState } from 'src/features/Groups/Details/types';

export type SelectGroupMembersProps = {
  id: string;
  placeholder: string;
  groupId?: string;
  defaultValue?: string[];
  onChange: (value: string[]) => void;
};

export const SelectGroupMembers: React.FC<SelectGroupMembersProps> = ({
  id,
  placeholder,
  groupId,
  defaultValue,
  onChange,
}) => {
  const { get } = useClient();
  const [members, setMembers] = useState<Array<MemberState>>([]);

  useEffect(() => {
    if (!groupId) return;
    get(`/groups/${groupId}/members?per_page=200&page=1`, (response: any) => {
      response?.data && setMembers(filterApiResponse(response));
    });
  }, [get, groupId]);

  return (
    <AntdSelect
      mode="multiple"
      showSearch
      size="large"
      id={id}
      style={{ width: '100%' }}
      placeholder={placeholder}
      defaultValue={defaultValue}
      optionFilterProp="label"
      onChange={value => onChange(value as string[])}
    >
      {members.map(({ memberInfo }) => {
        const label =
          `${memberInfo.firstname ?? ''} ${memberInfo.lastname ?? ''}`.trim() ||
          memberInfo.mail ||
          memberInfo.id;
        return (
          <AntdSelect.Option key={memberInfo.id} value={memberInfo.id} label={label}>
            {label}
          </AntdSelect.Option>
        );
      })}
    </AntdSelect>
  );
};
